import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-bolt",
  templateUrl: "./med-icon-bolt.component.html",
})
export class MedIconBoltComponent extends SvgMixinComponent {}
